import {
    LOGIN_SUCCESS,
    LOGIN_FAIL,
    USER_LOADED_SUCCESS,
    USER_LOADED_FAIL,
    LOGOUT, REFRESH_SUCCESS, SET_MAINTENANCE_STATUS
} from './types';
import axiosHandler from "../services/https";

export const load_user = () => async dispatch => {
    try {
        console.log("Fetching info!");
        const res = await axiosHandler.getInstance().get(`${process.env.REACT_APP_KEYCLOAK_HOSTNAME}${process.env.REACT_APP_KEYCLOAK_USERINFO_ENDPOINT}`);
        dispatch({
            type: USER_LOADED_SUCCESS,
            payload: res.data
        });
        console.log(`Sending new token...`);
        sendToken();
    } catch (err) {
        dispatch({
            type: USER_LOADED_FAIL
        });
        logout()
    }
};

export const login = () => async dispatch => {
    const redirectUri = document.location.origin + process.env.REACT_APP_KEYCLOAK_REDIRECT_URI;
    window.location.href = `${process.env.REACT_APP_KEYCLOAK_HOSTNAME}${process.env.REACT_APP_KEYCLOAK_AUTHORIZE_ENDPOINT}?client_id=${process.env.REACT_APP_KEYCLOAK_CLIENT_ID}&redirect_uri=${encodeURIComponent(redirectUri)}&response_mode=fragment&response_type=code&scope=openid`;
};

export const sendToken = () => async dispatch => {
    let accessToken = localStorage.getItem('access');
    let refreshToken = localStorage.getItem('refresh');
    let idToken = localStorage.getItem('id');
    // comunico al WebGIS i dati del token
    const iFrame = document.querySelector("iframe");
    const data = {
        access_token: accessToken,
        refresh_token: refreshToken,
        id_token: idToken
    };
    iFrame.contentWindow.postMessage(data, "*");
}

export const loginWithToken = (tokenResponse) => async dispatch => {
    if (tokenResponse && tokenResponse.data && tokenResponse.data.access_token) {
        axiosHandler.setToken(tokenResponse.data.access_token)
        axiosHandler.setToken(tokenResponse.data.refresh_token)
        axiosHandler.setToken(tokenResponse.data.id_token)
        // salva l'autenticazione a partire da res.data
        dispatch({
            type: LOGIN_SUCCESS,
            payload: tokenResponse.data
        });
        dispatch(load_user());
    } else {
        dispatch({
            type: LOGIN_FAIL
        });
    }
};

export const setMaintenanceStatus = (maintenanceStatus) => dispatch => {
    dispatch({
        type: SET_MAINTENANCE_STATUS,
        payload: maintenanceStatus
    });
}

export const logout = (doLogin = false) => dispatch => {
    // clearing the session
    const isAuthenticated = localStorage.getItem('access');
    if (isAuthenticated) {
        const refresh = localStorage.getItem('refresh');
        const id = localStorage.getItem('id');
        const postParams = new URLSearchParams();
        postParams.append('refresh_token', `${refresh}`);
        postParams.append('id_token', `${id}`);
        postParams.append('redirect_url', `${document.location.origin}`);
        axiosHandler.getInstance().post(
            `${process.env.REACT_APP_API_URL}/store/logout`, postParams)
            .then((response) => {
                if (doLogin === true) {
                    login();
                } else {
                    dispatch({
                        type: LOGOUT
                    });
                }
            })
            .catch(err => {
                console.log('CANNOT LOGOUT', err);
                if (doLogin === true) {
                    login();
                } else {
                    dispatch({
                        type: LOGOUT
                    });
                }
            });
    } else {
        console.log('LOGOUT NOT NEEDED');
        if (doLogin === true) {
            login();
        } else {
            dispatch({
                type: LOGOUT
            });
        }
    }

};
